export default function LoadingScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-gray-600">Loading...</div>
    </div>
  );
}
